import { ChainOfThoughtContent, ChainOfThoughtItem, ChainOfThoughtTrigger } from "@prelude-ai/design-system"
import { CheckCircle } from "lucide-react"
import type { ChatMessage as ChatMessageType } from "../types"
import ToolOutput from "./ToolOutput"

type ToolCallMessageProps = {
  message: ChatMessageType
}

function extractToolOutput(message: ChatMessageType): unknown {
  if (message.toolResult && Object.keys(message.toolResult).length > 0) {
    return message.toolResult
  }

  if (message.content) {
    const jsonMatch = message.content.match(/returned:\s*(\{[\s\S]*\}|\[[\s\S]*\])$/i)
    if (jsonMatch?.[1]) {
      try {
        return JSON.parse(jsonMatch[1])
      } catch {
        // Failed to parse, fall through
      }
    }

    try {
      return JSON.parse(message.content)
    } catch {
      return message.content
    }
  }

  return null
}

export default function ToolCallMessage({ message }: ToolCallMessageProps) {
  if (!message.id) {
    throw new Error("Message received without an id")
  }
  const output = extractToolOutput(message)
  return (
    <>
      <ChainOfThoughtTrigger leftIcon={<CheckCircle className="size-4 text-green-500" />}>
        <span className="font-medium">{message.toolName}</span>
      </ChainOfThoughtTrigger>
      <ChainOfThoughtContent>
        <ChainOfThoughtItem>
          <ToolOutput output={output} />
        </ChainOfThoughtItem>
      </ChainOfThoughtContent>
    </>
  )
}
